import React from "react";
import "./cookiespolicy.css";


const CookiesPolicy = () => {
  return (
    <div className="cookies">
    <div className="container mx-auto p-6 max-w-3xl text-gray-800 text-center">
      <h1 className="text-3xl font-bold text-blue-700">Cookies Policy of eSmaaash</h1>
      <p className="mt-4 text-lg">
      Effective Date: 02 / 09 / 2024 <br></br>



<h2 className="text-2xl text-center font-semibold mt-6 text-gray-900">1. Introduction</h2>

<p className="mt-2">
Welcome to esmaaash.com (the “Website”), owned and operated by Smaaash Entertainment Pvt. Ltd., a
company incorporated under the Companies Act of 1956. Our corporate office is located at:
Metro Avenue G-2, Ground Floor
Andheri-Kurla Road
Next to WEH Metro Station
Andheri (East), Mumbai - 400093 <br></br>  Smaaash Entertainment Pvt. Ltd. and its affiliates (“Smaaash”, “esmaaash”, “we”, “our”, “Company” or
“us”) are committed to collecting and processing information about you (“you”, “user”, or “visitor”) and
others who interact with our services. We adhere to all relevant laws concerning personal information and
are dedicated to protecting your rights as outlined in this Privacy Policy (“Policy”). This Policy explains
how we collect, use, and manage your personal information during and after your interactions with us.    </p>

<h2 className="text-2xl font-semibold mt-6 text-gray-900">2. Who We Are</h2>

<p className="mt-2">
Smaaash offers a diverse range of entertainment services, including but not limited to virtual games,
amusement activities, and related services (collectively referred to as the “Services”). Our Services
include access to our physical facilities, participation in events we host, and the use of our website(s) and
mobile application(s) (collectively referred to as the “Site(s)”).      </p>



<h2 className="text-2xl font-semibold mt-6 text-gray-900">3. Information We Collect</h2>


<p className="mt-2">
We collect information about you and your interactions with our Services. This information is essential
for entering into or performing a contract with you and failure to provide it may impact our ability to
deliver the requested services. The information we collect falls into three categories:     </p>
<br></br><br></br>
1. Information Collected Directly from You
When you use our Services or participate in activities, you may provide:

Personal Details: Name, email address, phone number, date of birth, gender, and other
identification information.

Event Participation: Information required for booking or participating in events, including your name and contact details.

Customer Service: Information provided when contacting us for support, including your name, email address, and details of your inquiry.

​

Please note that information shared through interactive features (e.g., chat functions) may become public
and could be stored.
<br></br><br></br>

2. Information Collected Automatically
We automatically gather certain information when you use our Services, including:
<br></br>
Device Information: IP address, device ID, device model, operating system, screen
<br></br>resolution, and time zone.

<br></br>Usage Data: Interaction with our Services, including browsing behavior and system activity (e.g., crash reports).

<br></br>Analytics: Data about your usage of our Site and Services to enhance our offerings.

​<br></br> <br></br>


3. Information Collected from Third Parties
When accessing our Services via third-party platforms (e.g., social media), we may collect
information from these platforms as permitted by their privacy settings. This includes:
o Social Media: Profile details, friends lists, and other information as allowed by your
privacy settings on platforms like Facebook, YouTube, Instagram, and Google.

​
<br></br> <br></br>
<h2 className="text-2xl font-semibold mt-6 text-gray-900">4. Cookies and Related Technologies
</h2>

<p className="mt-2">
We use cookies and similar technologies to recognize your device, understand your preferences, and
enhance your experience. Third parties may also set cookies when you use our Site or Services.    </p>
<br></br>
1. Cookies
Cookies are small files placed on your device to track your activity and customize your
experience. You can manage cookies through your browser settings, though blocking cookies
may affect the functionality of our Site.
<br></br>
2. Analytics
we use analytics services, including Google® Analytics, to track usage and improve our Services.
For more details on Google’s privacy practices and how to opt out, visit Google’s Privacy Policy.
 
<br></br><br></br>
<h2 className="text-2xl font-semibold mt-6 text-gray-900">5. How We Use Your Information
</h2>

We use the collected information to:
<br></br>
Operate and enhance our Services.
<br></br>
Manage event bookings and customer support.
<br></br>
Monitor and improve service quality.
<br></br>
Conduct marketing and promotional activities.
<br></br>
Ensure compliance with legal obligations and prevent fraud.
<br></br>
Operate E-sports events and provide opportunities for participation in tournaments.
<br></br>
Provide customer service by responding to inquiries.
<br></br> <br></br>
​

​<h2 className="text-2xl font-semibold mt-6 text-gray-900">6. Sharing Your Information with Third Parties
</h2>



We may share your information with third-party service providers to assist with our Services, such as:

Event management and booking systems.

Marketing and advertising platforms.

Customer support providers.

Payment Processing: We use Razorpay Payment Gateway for payment processing. Razorpay's privacy practices apply to transactions made through their platform. For details on how Razorpay handles your information, please refer to Razorpay Privacy Policy.


We may also share information to comply with legal requirements or in response to lawful requests.
<br></br> <br></br>

​<h2 className="text-2xl font-semibold mt-6 text-gray-900">7. Retaining and Deleting Personal Information

</h2>

We will retain your personal information only as long as necessary to fulfill the purposes outlined in this
Policy or to comply with legal obligations. You may request the deletion of your information through our
support channels.
<br></br> <br></br>

​<h2 className="text-2xl font-semibold mt-6 text-gray-900">8. Policy for Minors

</h2>

<p>
Our Services are not intended for individuals under the age of 18. Users under 18 should not use our
Services without parental or guardian consent. We do not knowingly collect, use, or disclose personal
information from individuals under 18 without verified consent from a parent or guardian, or as permitted
by law. If a person under 18 uses our Services without such consent, we disclaim any responsibility for
their use and any consequences thereof. Parents or guardians are responsible for monitoring their child’s
use of our Services. If you are a parent or guardian and believe your child under 18 has provided us with
personal information without your consent, please contact us to request the deletion of such information.</p>
<br></br> <br></br>

​<h2 className="text-2xl font-semibold mt-6 text-gray-900">9. Third-Party Links

</h2>

<p>

The Website may contain links to third-party websites that are not controlled by esmaaash. We are not
responsible for the content, privacy policies, or practices of these third-party websites. Accessing third-
party websites is at your own risk, and we disclaim any liability for any damages or issues arising from
your use of such websites.</p>
<br></br> <br></br>

​<h2 className="text-2xl font-semibold mt-6 text-gray-900">10. Security of Your Information

</h2>

<p>

We implement security measures to protect your information from unauthorized access, alteration, or
disclosure. Access to your data is limited to authorized personnel only.</p>
<br></br> <br></br>

​<h2 className="text-2xl font-semibold mt-6 text-gray-900">11. Your Privacy Rights

</h2>

<p>

You may have rights to access, correct, or delete your personal information. To exercise these rights or
for any privacy-related inquiries, please contact us at the address provided below.</p>
<br></br> <br></br>

​<h2 className="text-2xl font-semibold mt-6 text-gray-900">12. Amendments

</h2>

<p>

We may periodically update this Privacy Policy to reflect changes in our practices or legal requirements.
Any significant updates will be communicated through our Website or other suitable channels. We
encourage you to review this Policy regularly to stay informed about how we are protecting your
information.</p>
<br></br> <br></br>

​<h2 className="text-2xl font-semibold mt-6 text-gray-900">13. Contact Us

</h2>

<p>

At Smaaash, we are committed to providing you with comprehensive information about our Website and
Services. Should you have any questions or need further assistance, please feel free to reach out to us at:
esports@smaaash-entertainment.in Contact Number: +91 22482 51749


For any grievances or concerns, please contact our Grievance Officer, Nilesh Kapile, directly at:
grievanceofficer@smaaash-entertainment.in Contact Number: +91 8657731179


We are here to help and ensure your experience with us is smooth and satisfactory.</p>
      </p>
    </div>
    </div>
  );
};

export default CookiesPolicy;
